import { render, staticRenderFns } from "./PatientPhoneCard.vue?vue&type=template&id=96a4e67a&scoped=true&"
import script from "./PatientPhoneCard.vue?vue&type=script&lang=ts&"
export * from "./PatientPhoneCard.vue?vue&type=script&lang=ts&"
import style0 from "./PatientPhoneCard.vue?vue&type=style&index=0&id=96a4e67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a4e67a",
  null
  
)

export default component.exports